import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPostcard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPostcard1"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM12 9H6V11H12V9ZM6 12.5H10V14.5H6V12.5ZM18 9H14V14H18V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPostcard1;
